import { DeleteAccountApplicationApi } from '../../generated/api';
import configuration from './configuration';

export default new DeleteAccountApplicationApi(configuration);
